import type { AccountFilters } from '@/graphql/generated/schema'

import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface AllocationRunState {
  accountFilters: AccountFilters | null
  orderId: string | null
}

const initialState: AllocationRunState = {
  accountFilters: null,
  orderId: null,
}

const allocationRunSlice = createSlice({
  name: 'allocationRun',
  reducerPath: 'allocationRun',
  initialState,
  reducers: {
    setAccountFilters(
      state: AllocationRunState,
      action: PayloadAction<AccountFilters>,
    ) {
      state.accountFilters = action.payload
    },
    clearAccountFilters(state: AllocationRunState) {
      state.accountFilters = null
    },
    setOrderId(state: AllocationRunState, action: PayloadAction<string>) {
      state.orderId = action.payload
    },
    clearOrderId(state: AllocationRunState) {
      state.orderId = null
    },
  },
})

export const { clearAccountFilters, clearOrderId } = allocationRunSlice.actions

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default allocationRunSlice
